import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import {
  cmntVector,
  likeVector,
  tProfilePic,
  tweetPic,
} from "./SmallComponents/Images";
import { FaTwitter } from "react-icons/fa";

function TweetCard({ data }) {
  const renderTextWithHashtags = (text) => {
    // Regular expression to match hashtags (words starting with #)
    const hashtagRegex = /#(\w+)/g;

    // Split the text by hashtags and iterate over each part
    return text.split(hashtagRegex).map((part, index) => {
      // Check if the part is a hashtag
      if (index % 2 === 1) {
        // If it's a hashtag, wrap it with a span with blue color
        return (
          <span key={index} style={{ color: "#1DA1F2" }}>
            #{part}
          </span>
        );
      } else {
        // If it's not a hashtag, return it as plain text
        return part;
      }
    });
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FFFFFF",
        borderRadius: "15px",
        p: 1,
        height: "100%",
        position: "relative",
      }}
    >
      <FaTwitter
        style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          color: "#1DA1F2",
          fontSize: "20px",
        }}
      />
      <Stack flexDirection={"row"} alignItems={"center"}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 0.5,
          }}
        >
          <Box
            component={"img"}
            alt=""
            src={data?.user?.profile_pic_url}
            width="30px"
            borderRadius={"50%"}
          />
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Roboto",
                fontSize: "14px",
                fontWeight: "700",
                color: "#000000",
              }}
            >
              {data?.user?.name}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "400",
                color: "#526471",
                mt: -0.5,
              }}
            >
              @{data?.user?.username}
            </Typography>
          </Box>
        </Box>
      </Stack>
      <Typography
        variant="body1"
        sx={{
          fontFamily: "Roboto",
          fontSize: "12px",
          fontWeight: "400",
          color: "#000000",
          my: 1,
        }}
      >
        {renderTextWithHashtags(data?.text)}
        {/* <span
          style={{
            color: "#1DA1F2",
          }}
        >
          #YourHashtag
        </span> */}
      </Typography>

      <Box
        sx={{
          borderRadius: "12px",
          overflow: "hidden",
          width: "100%",
          height: "250px",
          mb: 1,
        }}
      >
        <Box
          component={"img"}
          alt=""
          src={data?.media_url?.length > 0 ? data?.media_url[0] : tweetPic}
          sx={{
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
      <Stack flexDirection={"row"} alignItems={"center"} gap={2} mx={1}>
        {[
          { icon: likeVector, num: data?.favorite_count ?? 0 },
          {
            icon: cmntVector,
            num: data?.reply_count ?? 0,
          },
        ].map(({ icon, num }, i) => (
          <Box
            key={i * Math.random() * num}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 0.5,
            }}
          >
            <Box component={"img"} alt="" src={icon} sx={{ width: "18px" }} />{" "}
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Roboto",
                fontSize: "12px",
                fontWeight: "500",
                color: "#000000",
              }}
            >
              {num}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Box>
  );
}

export default TweetCard;
